import {
  useBatchStart,
  useBatchStop,
  useBatchRemove,
} from 'scenes/Integrations/data';
import { useGridApiContext } from '@gogame/data-grid';
import { Actions, Action } from '@gogame/components';

export default function IntegrationsBulkActions() {
  const [batchStart] = useBatchStart();
  const [batchStop] = useBatchStop();
  const [batchRemove] = useBatchRemove();
  const apiRef = useGridApiContext();

  const handleBatchStart = () => {
    return batchStart(getSelectedRows(apiRef));
  };

  const handleBatchStop = () => {
    return batchStop(getSelectedRows(apiRef));
  };

  const handleBatchRemove = () => {
    return batchRemove(getSelectedRows(apiRef));
  };

  return (
    <Actions>
      <Action button={true} label={'Activate'} onClick={handleBatchStart} />
      <Action button={true} label={'Deactivate'} onClick={handleBatchStop} />
      <Action button={true} label={'Delete'} onClick={handleBatchRemove} />
    </Actions>
  );
}

function getSelectedRows(apiRef) {
  return [...apiRef.current.getSelectedRows().values()];
}
